function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { CVResp } from './CVResp';
import { chain, forEach, isInteger, map } from 'lodash';
export var CVModel = /*#__PURE__*/function () {
  function CVModel() {
    _classCallCheck(this, CVModel);
    _defineProperty(this, "resp", []);
    _defineProperty(this, "reporteEdicion", null);
    _defineProperty(this, "valid", true);
  }
  return _createClass(CVModel, [{
    key: "paraEdicion",
    value:
    // --------------------------

    function paraEdicion(reportecv) {
      this.reporteEdicion = reportecv;
    }
  }, {
    key: "nuevaPreg",
    value: function nuevaPreg(q, superq, respmodel, idx, params) {
      var r = new CVResp(q, superq, respmodel, idx);
      this.resp.push(r);

      // si es de tipo  o PARAM2 o PARAMOCULTO, la pregunta puede estar rellena en los parámetros
      if ((q.tq == 'PARAM' || q.tq == 'PARAM2' || q.tq == 'PARAMOCULTO') && params && params[q.q]) {
        respmodel.t = params[q.q];
      }
      if (this.reporteEdicion) {
        // idq
        var idq = Number(q.qref.replace(/^(_ref_)/, ''));
        if (isInteger(idq)) {
          r.conOriginal(this.reporteEdicion.listaRespuestas.respuestas[idq]);
        }
      }
      return r;
    }
  }, {
    key: "validar",
    value: function validar() {
      var omitirTipoFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.valid = map(this.resp, function (r) {
        return r.esTipoFile() && omitirTipoFile || r.validaPreg();
      }).find(function (valid) {
        return !valid;
      }) == undefined;
      return this.valid;
    }
  }, {
    key: "respuestas",
    value: function respuestas() {
      return chain(this.resp).map(function (r) {
        return r.generaReq();
      }).value();
    }
  }, {
    key: "respuestasEdicion",
    value: function respuestasEdicion() {
      return chain(this.resp).flatMap(function (r) {
        return r.generaReqEdit();
      }).value();
    }
  }, {
    key: "files",
    value: function files() {
      return chain(this.resp).flatMap(function (r) {
        return r.generaFiles();
      }).value();
    }
  }, {
    key: "__rellenaTest",
    value: function __rellenaTest() {
      forEach(this.resp, function (r) {
        return r.__rellenaTest();
      });
    }
  }]);
}();